/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mCardItem.vue?vue&type=template&id=3e891116&scoped=true"
import script from "./mCardItem.vue?vue&type=script&lang=js"
export * from "./mCardItem.vue?vue&type=script&lang=js"
import style0 from "./mCardItem.vue?vue&type=style&index=0&id=3e891116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e891116",
  null
  
)

export default component.exports